(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grova-faq-page"] && !Shopify.designMode) return;
  try {
    
  const initializeGrovaFaq = (scope = document) => {
    scope.querySelectorAll('.grova-faq-page').forEach((root) => {
      if (root.dataset.faqReady === 'true') return;
      root.dataset.faqReady = 'true';

      const items = [...root.querySelectorAll('.grova-faq-page__item')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const duration = 420;
      const easing = 'cubic-bezier(.22, .61, .36, 1)';

      const finishTransition = (answer, callback) => {
        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          answer.removeEventListener('transitionend', finish);
          callback();
        };

        answer.addEventListener('transitionend', finish);
        window.setTimeout(finish, duration + 80);
      };

      const openItem = (item) => {
        const answer = item.querySelector('.grova-faq-page__answer');
        item.dataset.animating = 'true';
        item.open = true;
        answer.style.transition = 'none';
        answer.style.height = '0px';
        answer.style.opacity = '0';
        const targetHeight = answer.scrollHeight;
        answer.getBoundingClientRect();
        answer.style.transition = `height ${duration}ms ${easing}, opacity 240ms ease`;
        answer.style.height = `${targetHeight}px`;
        answer.style.opacity = '1';

        finishTransition(answer, () => {
          answer.style.height = 'auto';
          answer.style.opacity = '1';
          answer.style.removeProperty('transition');
          delete item.dataset.animating;
        });
      };

      const closeItem = (item) => {
        const answer = item.querySelector('.grova-faq-page__answer');
        item.dataset.animating = 'true';
        const startHeight = answer.getBoundingClientRect().height;
        answer.style.transition = 'none';
        answer.style.height = `${startHeight}px`;
        answer.style.opacity = '1';
        answer.getBoundingClientRect();
        answer.style.transition = `height ${duration}ms ${easing}, opacity 240ms ease`;
        answer.style.height = '0px';
        answer.style.opacity = '0';

        finishTransition(answer, () => {
          item.open = false;
          answer.style.removeProperty('height');
          answer.style.removeProperty('opacity');
          answer.style.removeProperty('transition');
          delete item.dataset.animating;
        });
      };

      items.forEach((item) => {
        const summary = item.querySelector('summary');
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (item.dataset.animating === 'true') return;

          if (reducedMotion.matches) {
            const shouldOpen = !item.open;
            items.forEach((otherItem) => {
              if (otherItem !== item) otherItem.open = false;
            });
            item.open = shouldOpen;
            return;
          }

          if (item.open) {
            closeItem(item);
            return;
          }

          items.forEach((otherItem) => {
            if (otherItem.open && otherItem.dataset.animating !== 'true') {
              closeItem(otherItem);
            }
          });
          openItem(item);
        });
      });
    });
  };

  initializeGrovaFaq();
  document.addEventListener('shopify:section:load', (event) => initializeGrovaFaq(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grova-mens-alcohol-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.gwrhReady === 'true') return;
      root.dataset.gwrhReady = 'true';
      const slider = root.querySelector('[data-gwrh-slider]');
      const track = root.querySelector('[data-gwrh-track]');
      const dots = [...root.querySelectorAll('.gwrh__dot')];
      const slides = [...root.querySelectorAll('[data-gwrh-slide]')];
      if (!slider || !track || slides.length < 2) return;
      let index = 0;
      let startX = 0;
      let currentX = 0;
      let dragging = false;
      const goTo = (nextIndex) => {
        index = Math.max(0, Math.min(nextIndex, slides.length - 1));
        track.style.transform = `translateX(-${index * 100}%)`;
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };
      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => goTo(dotIndex)));
      slider.addEventListener('pointerdown', (event) => {
        dragging = true;
        startX = event.clientX;
        currentX = startX;
        track.style.transition = 'none';
        slider.setPointerCapture(event.pointerId);
      });
      slider.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        currentX = event.clientX;
        track.style.transform = `translateX(calc(-${index * 100}% + ${currentX - startX}px))`;
      });
      slider.addEventListener('pointerup', () => {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        const difference = currentX - startX;
        if (difference < -45) goTo(index + 1);
        else if (difference > 45) goTo(index - 1);
        else goTo(index);
      });
    };
    document.querySelectorAll('[data-gwrh]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-gwrh]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grova-mushroom-advertorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-grova-advertorial]');
    if (!root) return;

    const days = root.querySelector('[data-countdown-days]');
    const hours = root.querySelector('[data-countdown-hours]');
    const minutes = root.querySelector('[data-countdown-minutes]');
    const seconds = root.querySelector('[data-countdown-seconds]');
    const key = 'grovaAdvertorialCountdownV3';
    const duration = 48 * 60 * 60 * 1000;
    let deadline = Number(localStorage.getItem(key));

    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + duration;
      localStorage.setItem(key, String(deadline));
    }

    const update = () => {
      let remaining = deadline - Date.now();
      if (remaining <= 0) {
        deadline = Date.now() + duration;
        localStorage.setItem(key, String(deadline));
        remaining = duration;
      }
      const totalSeconds = Math.floor(remaining / 1000);
      days.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
      hours.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
      minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
    };

    update();
    window.setInterval(update, 1000);

    const mobileSticky = root.querySelector('[data-mobile-sticky-cta]');
    const articleStart = root.querySelector('#grova-advertorial-article');
    const buyBox = root.querySelector('.grova-advertorial__buy-box');
    const inlineOffer = root.querySelector('.grova-advertorial__inline-offer');
    const mobileProductCard = root.querySelector('.grova-advertorial__product-card--mobile');
    const bottomMobileCta = root.querySelector('[data-bottom-mobile-cta]');

    const updateMobileSticky = () => {
      if (!mobileSticky || !articleStart || !buyBox || !inlineOffer || !mobileProductCard || !bottomMobileCta) return;
      const isMobile = window.matchMedia('(max-width: 640px)').matches;
      const articleHasStarted = articleStart.getBoundingClientRect().top <= window.innerHeight * 0.45;
      const buyRect = buyBox.getBoundingClientRect();
      const inlineOfferRect = inlineOffer.getBoundingClientRect();
      const productRect = mobileProductCard.getBoundingClientRect();
      const bottomCtaRect = bottomMobileCta.getBoundingClientRect();
      const buyBoxIsVisible = buyRect.top < window.innerHeight && buyRect.bottom > 0;
      const inlineOfferIsVisible = inlineOfferRect.top < window.innerHeight && inlineOfferRect.bottom > 0;
      const productCardIsVisible = productRect.top < window.innerHeight && productRect.bottom > 0;
      const bottomCtaIsVisible = bottomCtaRect.top < window.innerHeight && bottomCtaRect.bottom > 0;
      const shouldShow = isMobile && articleHasStarted && !buyBoxIsVisible && !inlineOfferIsVisible && !productCardIsVisible && !bottomCtaIsVisible;

      mobileSticky.classList.toggle('is-visible', shouldShow);
      mobileSticky.setAttribute('aria-hidden', String(!shouldShow));
    };

    updateMobileSticky();
    window.addEventListener('scroll', updateMobileSticky, { passive: true });
    window.addEventListener('resize', updateMobileSticky);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grova-native-reviews-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.gnr');

    sections.forEach((section) => {
      const tabs = [...section.querySelectorAll('[data-gnr-tab]')];
      const panels = [...section.querySelectorAll('[data-gnr-panel]')];

      const activate = (tab) => {
        const target = tab.dataset.gnrTab;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.gnrPanel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = tabs[(index + direction + tabs.length) % tabs.length];
          activate(next);
          next.focus();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grova-three-plan-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-grova-plans]');
    if (!section) return;

    const saleHeader = section.querySelector('.grova-plans__sale-header');
    const obsoleteOfferBanner = document.querySelector('#replo-section-5bb1dfb0-ee86-4f1d-b679-84eb18b417a6');
    obsoleteOfferBanner?.closest('.shopify-section')?.remove();
    const applyOfferSpacing = () => {
      const topSpacing = window.matchMedia('(max-width: 640px)').matches ? '20px' : '56px';
      section.style.setProperty('padding-top', topSpacing, 'important');
      saleHeader?.style.setProperty('margin', '0', 'important');
    };
    applyOfferSpacing();
    window.addEventListener('resize', applyOfferSpacing);
    if (saleHeader) {
      saleHeader.classList.add('grova-plans__sale-header--site-top');
      saleHeader.style.setProperty('margin', '0', 'important');
      document.body.prepend(saleHeader);
    }

    const pad = (value) => String(value).padStart(2, '0');
    const countdownKey = 'grovaAdvertorialCountdownV4';
    const countdownDuration = 3 * 24 * 60 * 60 * 1000;
    let deadline = Number(localStorage.getItem(countdownKey));
    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + countdownDuration;
      localStorage.setItem(countdownKey, String(deadline));
    }
    const updateCountdown = () => {
      let remaining = deadline - Date.now();
      if (remaining <= 0) {
        deadline = Date.now() + countdownDuration;
        localStorage.setItem(countdownKey, String(deadline));
        remaining = countdownDuration;
      }
      const seconds = Math.floor(remaining / 1000);
      saleHeader?.querySelectorAll('[data-plan-days]').forEach((element) => { element.textContent = pad(Math.floor(seconds / 86400)); });
      saleHeader?.querySelectorAll('[data-plan-hours]').forEach((element) => { element.textContent = pad(Math.floor((seconds % 86400) / 3600)); });
      saleHeader?.querySelectorAll('[data-plan-minutes]').forEach((element) => { element.textContent = pad(Math.floor((seconds % 3600) / 60)); });
      saleHeader?.querySelectorAll('[data-plan-seconds]').forEach((element) => { element.textContent = pad(seconds % 60); });
    };

    const dispatchKey = 'grovaShipsTodayCountdownV1';
    const dispatchDuration = ((1 * 60 * 60) + (52 * 60) + 47) * 1000;
    const dispatchResetThreshold = 8 * 60 * 1000;
    let dispatchDeadline = Number(localStorage.getItem(dispatchKey));
    if (!dispatchDeadline || dispatchDeadline - Date.now() <= dispatchResetThreshold) {
      dispatchDeadline = Date.now() + dispatchDuration;
      localStorage.setItem(dispatchKey, String(dispatchDeadline));
    }
    const updateDispatchCountdown = () => {
      let remaining = dispatchDeadline - Date.now();
      if (remaining <= dispatchResetThreshold) {
        dispatchDeadline = Date.now() + dispatchDuration;
        localStorage.setItem(dispatchKey, String(dispatchDeadline));
        remaining = dispatchDuration;
      }
      const totalSeconds = Math.floor(remaining / 1000);
      const label = `${pad(Math.floor(totalSeconds / 3600))}h ${pad(Math.floor((totalSeconds % 3600) / 60))}m ${pad(totalSeconds % 60)}s`;
      section.querySelectorAll('[data-ships-countdown]').forEach((element) => { element.textContent = label; });
    };

    section.querySelectorAll('[data-plan-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('.grova-plan-carousel__track');
      const slides = carousel.querySelectorAll('.grova-plan-carousel__slide');
      const dots = carousel.querySelectorAll('.grova-plan-carousel__dots button');
      let index = 0;
      const move = (newIndex) => {
        index = (newIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };
      carousel.querySelector('.grova-plan-carousel__arrow--prev').addEventListener('click', () => move(index - 1));
      carousel.querySelector('.grova-plan-carousel__arrow--next').addEventListener('click', () => move(index + 1));
      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => move(dotIndex)));

      const viewport = carousel.querySelector('.grova-plan-carousel__viewport');
      let pointerStartX = null;
      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        pointerStartX = event.clientX;
      });
      viewport.addEventListener('pointerup', (event) => {
        if (event.pointerType !== 'mouse') return;
        if (pointerStartX === null) return;
        const distance = event.clientX - pointerStartX;
        pointerStartX = null;
        if (Math.abs(distance) < 18) return;
        move(distance < 0 ? index + 1 : index - 1);
      });
      viewport.addEventListener('pointercancel', () => { pointerStartX = null; });
      let touchStartX = null;
      let touchStartY = null;
      viewport.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });
      viewport.addEventListener('touchend', (event) => {
        if (touchStartX === null || touchStartY === null) return;
        const touch = event.changedTouches[0];
        const distanceX = touch.clientX - touchStartX;
        const distanceY = touch.clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(distanceX) < 18 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        move(distanceX < 0 ? index + 1 : index - 1);
      }, { passive: true });
      viewport.addEventListener('dragstart', (event) => event.preventDefault());
    });

    const cartClearUrl = section.dataset.cartClearUrl;
    const cartAddUrl = section.dataset.cartAddUrl;
    const checkoutUrl = section.dataset.checkoutUrl;
    const checkoutSessionKey = 'grovaCheckoutStarted';
    const clearCart = () => fetch(cartClearUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: '{}'
    }).catch((error) => console.error('Unable to clear returned checkout cart', error));
    const resetPurchaseButtons = () => {
      section.querySelectorAll('[data-subscribe], [data-onetime]').forEach((button) => {
        if (button.dataset.originalLabel) button.textContent = button.dataset.originalLabel;
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
    };
    window.addEventListener('pagehide', resetPurchaseButtons);
    window.addEventListener('pageshow', (event) => {
      resetPurchaseButtons();
      const navigation = performance.getEntriesByType('navigation')[0];
      const returnedFromCheckout = sessionStorage.getItem(checkoutSessionKey) === 'true';
      if (event.persisted || navigation?.type === 'back_forward' || returnedFromCheckout) {
        sessionStorage.removeItem(checkoutSessionKey);
        clearCart();
      }
    });
    const burstConfetti = (button) => {
      const rect = button.getBoundingClientRect();
      const colors = ['#edc75c', '#10a43f', '#7aa85d', '#ffffff', '#d7ebe5', '#eadff1'];
      for (let index = 0; index < 24; index += 1) {
        const piece = document.createElement('span');
        piece.className = 'grova-plan-confetti';
        piece.style.left = `${rect.left + rect.width / 2}px`;
        piece.style.top = `${rect.top + rect.height / 2}px`;
        piece.style.background = colors[index % colors.length];
        piece.style.setProperty('--confetti-x', `${(Math.random() - 0.5) * 240}px`);
        piece.style.setProperty('--confetti-y', `${-55 - Math.random() * 150}px`);
        piece.style.setProperty('--confetti-rotate', `${Math.random() * 720 - 360}deg`);
        document.body.appendChild(piece);
        window.setTimeout(() => piece.remove(), 760);
      }
    };
    const addPurchase = async (card, button, subscription) => {
      if (button.getAttribute('aria-busy') === 'true') return;
      const quantity = Math.max(1, Number(card.querySelector('[data-quantity-value]').textContent) || 1);
      const variantId = subscription ? card.dataset.variantId : (card.dataset.onetimeVariantId || card.dataset.variantId);
      const item = { id: Number(variantId), quantity };
      if (subscription) item.selling_plan = Number(card.dataset.sellingPlanId);
      const items = [item];
      if (subscription && (card.dataset.plan === '2' || card.dataset.plan === '3')) {
        items.push({
          id: 60193621213518,
          quantity,
          properties: {
            _grova_free_gift: 'true',
            _grova_gift_source: 'subscription'
          }
        });
      }
      if (subscription && card.dataset.plan === '3') {
        items.push({
          id: 60193613775182,
          quantity,
          properties: {
            _grova_free_gift: 'true',
            _grova_gift_source: 'subscription'
          }
        });
      }
      const label = button.textContent;
      button.dataset.originalLabel = label;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = 'ADDING…';
      burstConfetti(button);
      try {
        await fetch(cartClearUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: '{}' });
        const response = await fetch(cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error('Unable to add this option');
        sessionStorage.setItem(checkoutSessionKey, 'true');
        window.location.assign(checkoutUrl);
      } catch (error) {
        console.error(error);
        button.textContent = label;
        button.removeAttribute('aria-busy');
        button.disabled = false;
        window.alert('Sorry, this option could not be added. Please try again.');
      }
    };

    section.querySelectorAll('[data-plan-card]').forEach((card) => {
      const quantityValue = card.querySelector('[data-quantity-value]');
      card.querySelector('[data-quantity-minus]').addEventListener('click', () => {
        quantityValue.textContent = String(Math.max(1, Number(quantityValue.textContent) - 1));
      });
      card.querySelector('[data-quantity-plus]').addEventListener('click', () => {
        quantityValue.textContent = String(Math.min(10, Number(quantityValue.textContent) + 1));
      });
      card.querySelector('[data-subscribe]').addEventListener('click', (event) => addPurchase(card, event.currentTarget, true));
      card.querySelector('[data-onetime]').addEventListener('click', (event) => addPurchase(card, event.currentTarget, false));
    });

    const stickyCta = document.querySelector('[data-plan-sticky-cta]');
    if (stickyCta) {
      const stickyLink = stickyCta.querySelector('a[href="#grova-plan-cards"]');
      if (stickyLink) {
        stickyLink.addEventListener('click', (event) => {
          event.preventDefault();
          const cards = document.querySelector('#grova-plan-cards');
          if (cards) cards.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      const observer = new IntersectionObserver((entries) => {
        const sectionIsVisible = entries.some((entry) => entry.isIntersecting);
        stickyCta.classList.toggle('is-visible', !sectionIsVisible);
        stickyCta.setAttribute('aria-hidden', String(sectionIsVisible));
      }, { threshold: 0.01 });
      observer.observe(section);
    }

    updateCountdown();
    updateDispatchCountdown();
    window.setInterval(() => {
      updateCountdown();
      updateDispatchCountdown();
    }, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grova-wine-ritual-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.gwrhReady === 'true') return;
      root.dataset.gwrhReady = 'true';
      const slider = root.querySelector('[data-gwrh-slider]');
      const track = root.querySelector('[data-gwrh-track]');
      const dots = [...root.querySelectorAll('.gwrh__dot')];
      const slides = [...root.querySelectorAll('[data-gwrh-slide]')];
      if (!slider || !track || slides.length < 2) return;
      let index = 0;
      let startX = 0;
      let currentX = 0;
      let dragging = false;
      const goTo = (nextIndex) => {
        index = Math.max(0, Math.min(nextIndex, slides.length - 1));
        track.style.transform = `translateX(-${index * 100}%)`;
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };
      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => goTo(dotIndex)));
      slider.addEventListener('pointerdown', (event) => {
        dragging = true;
        startX = event.clientX;
        currentX = startX;
        track.style.transition = 'none';
        slider.setPointerCapture(event.pointerId);
      });
      slider.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        currentX = event.clientX;
        track.style.transform = `translateX(calc(-${index * 100}% + ${currentX - startX}px))`;
      });
      slider.addEventListener('pointerup', () => {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        const difference = currentX - startX;
        if (difference < -45) goTo(index + 1);
        else if (difference > 45) goTo(index - 1);
        else goTo(index);
      });
    };
    document.querySelectorAll('[data-gwrh]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-gwrh]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
